__turbopack_context__.v({
  "backgroundImage": "introSmall-module-scss-module__HSLKYq__backgroundImage",
  "intro": "introSmall-module-scss-module__HSLKYq__intro",
  "introContainer": "introSmall-module-scss-module__HSLKYq__introContainer",
  "introDescription": "introSmall-module-scss-module__HSLKYq__introDescription",
  "introTitle": "introSmall-module-scss-module__HSLKYq__introTitle",
});
